declare var process : {
  env: {
      NODE_ENV: string
  }
}

export class ENV {
  public static get isDev(): boolean {
    return process.env.NODE_ENV === 'development'
  }

  public static get isProd(): boolean {
    return process.env.NODE_ENV === 'production'
  }

  public static define(prodValue:any, otherwiseValue:any): any {
    return ENV.isProd ? prodValue : otherwiseValue
  }
}